/* Notice slideshow — externalized from sections/notice-slideshow.liquid so the
   browser can cache it and the parser is not blocked (defer on inline scripts
   is ignored). Finds every slideshow instance by id prefix.

   The track is not a scroll container. Slides move with a CSS transform on the
   track (a transition for the glide, none while dragging). Browsers latch a
   wheel/trackpad gesture to the first scroller under the cursor that can take
   the gesture's opening delta, so the previous native horizontal scroller,
   which fills the viewport at the top of the page, swallowed every slightly
   diagonal vertical swipe and the page did not move. Movement now comes only
   from script: dots, arrow keys, autoplay, pointer drag and clearly horizontal
   wheel gestures. */
(function () {
  if (window.__noticeSlideshowLoaded) return;
  window.__noticeSlideshowLoaded = true;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function initSection(outer) {
    if (!outer) return;

    /* Clear previous listeners/timers if re-initializing in the editor */
    if (outer._slideshowCleanup) outer._slideshowCleanup();
    if (outer._slideshowTimer) clearInterval(outer._slideshowTimer);

    var track = outer.querySelector('.notice-slideshow');
    var slides = Array.from(outer.querySelectorAll('.slide-item'));
    // Hero first (3 Nov 2026): slides after the first render with data-srcset/data-src (stacked slides are
    // all "in viewport", so loading=lazy fetched every slide alongside the hero). Hydrate them once the first
    // image has loaded, on the first interaction, before any advance, or after 6 s.
    var restHydrated = false;
    function hydrateRest() {
      if (restHydrated) return; restHydrated = true;
      slides.slice(1).forEach(function (slide) {
        slide.querySelectorAll('source[data-srcset]').forEach(function (so) { so.setAttribute('srcset', so.getAttribute('data-srcset')); so.removeAttribute('data-srcset'); });
        slide.querySelectorAll('img[data-src]').forEach(function (img) { img.loading = 'eager'; img.setAttribute('src', img.getAttribute('data-src')); img.removeAttribute('data-src'); }); // eager: hidden slides never pass Chrome's lazy-load, and autoplay now waits for the image
      });
    }
    // Image state (review 4 Nov 2026): no src yet = deferred (not ready, hydrate); src and complete = done, whether it
    // painted or 404'd. A broken image must not freeze autoplay, and a video first slide counts as ready.
    function imgReady(img) { if (!img) return true; if (!img.getAttribute('src')) return false; return !!img.complete; }
    function firstSlideImg() { var s0 = slides[0]; if (!s0 || s0.querySelector('video')) return null; return s0.querySelector('img'); }
    var dotItems = Array.from(outer.querySelectorAll('.notice-dots li'));
    if (!track || slides.length < 2) return;
    /* Own compositor layer: a drag then moves the slides without repainting
       them every frame (~100 paints per drag without it). */
    track.style.willChange = 'transform';

    var current = 0;
    var total = slides.length;
    var timer = null;
    var restartTimer;
    var pageScrollTimer;
    var wheelIdle;
    var visibilityObserver = null;
    var isPointerInside = false;
    var isUserInteracting = false;
    var isPageScrolling = false;
    var isHeroVisible = true;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var cleanup = [];

    function trackWidth() { return track.clientWidth || track.offsetWidth || 1; }

    function listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      cleanup.push(function () { target.removeEventListener(eventName, handler, options); });
    }

    /* Put the track at `pos` slides (fractional while dragging). Percent units
       keep resting positions exact through window resizes and rotation. */
    function render(pos, instant) {
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-pos * 100) + '%)';
      if (instant) { void track.offsetWidth; track.style.transition = ''; }
    }

    /* Where the track is right now, in slides, even in the middle of a glide. */
    function currentPos() {
      var t = getComputedStyle(track).transform;
      if (!t || t === 'none') return current;
      try { return -new DOMMatrixReadOnly(t).m41 / trackWidth(); } catch (_) { return current; }
    }

    function setActive(index) {
      current = ((index % total) + total) % total;
      dotItems.forEach(function (li, i) {
        var on = i === current;
        li.classList.toggle('active', on);
        var btn = li.querySelector('button');
        if (btn) { if (on) { btn.setAttribute('aria-current', 'true'); } else { btn.removeAttribute('aria-current'); } }
      });
    }

    function syncVideos(idx, forcePauseAll) {
      slides.forEach(function (slide, i) {
        slide.querySelectorAll('video').forEach(function (v) {
          if (!forcePauseAll && isHeroVisible && i === idx) {
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      });
    }

    function pauseVideos() { syncVideos(current, true); }

    function goTo(index, instant) {
      if (index !== 0) hydrateRest();
      var idx = ((index % total) + total) % total;
      render(idx, instant);
      setActive(idx);
      syncVideos(idx);
    }

    function firstSlideReady() {
      // Do not rotate away from slide 1 before its image has painted: on slow 4G
      // the 5 s timer used to fire before the hero ever loaded (A07-001 / A03-001).
      return imgReady(firstSlideImg());
    }

    function shouldAutoplay() {
      var tier = window.NoticeDeviceTier;
      if (tier && (tier.isLowEnd || tier.slowNet || tier.saveData)) return false;
      if (!firstSlideReady()) return false;
      return isHeroVisible &&
        !isUserInteracting &&
        !isPointerInside &&
        !isPageScrolling &&
        document.visibilityState !== 'hidden' &&
        !(reduceMotion && reduceMotion.matches);
    }

    function startAutoplay() {
      if (timer || !shouldAutoplay()) return;
      timer = setInterval(function () {
        // never rotate onto a slide whose image is not in yet (deferred slides on slow networks): hydrate and wait a tick
        var nxt = slides[((current + 1) % total + total) % total]; var nimg = nxt && nxt.querySelector('img');
        if (nimg && !imgReady(nimg)) { hydrateRest(); return; }
        goTo(current + 1);
      }, 5000);
      outer._slideshowTimer = timer;
    }

    function stopAutoplay() { clearInterval(timer); timer = null; outer._slideshowTimer = null; }

    function restartAutoplay(delay) {
      clearTimeout(restartTimer);
      restartTimer = setTimeout(startAutoplay, delay || 250);
    }

    function pauseForUser() {
      isUserInteracting = true;
      stopAutoplay();
      clearTimeout(restartTimer);
    }

    function resumeAfterUser(delay) {
      isUserInteracting = false;
      restartAutoplay(delay || 650);
    }

    dotItems.forEach(function (li, i) {
      listen(li.querySelector('button'), 'click', function () {
        pauseForUser();
        goTo(i);
        resumeAfterUser(900);
      });
    });

    /* Keyboard navigation: ArrowLeft/Right move between slides when focus is
       within the slideshow (e.g. on a dot or a slide CTA). */
    listen(outer, 'keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.keyCode === 37) {
        pauseForUser(); goTo(current - 1); resumeAfterUser(900);
      } else if (e.key === 'ArrowRight' || e.keyCode === 39) {
        pauseForUser(); goTo(current + 1); resumeAfterUser(900);
      } else {
        return;
      }
      e.preventDefault();
    });

    listen(outer, 'mouseenter', function () {
      isPointerInside = true;
      stopAutoplay();
    });
    listen(outer, 'mouseleave', function () {
      isPointerInside = false;
      restartAutoplay();
    });

    /* Pointer drag (touch, pen, primary mouse button). touch-action:pan-y on
       the track leaves vertical pans to the browser; a horizontal pan is
       handled here. The axis is decided after 8px by the browser's own rule
       (mostly sideways is ours), the track follows the pointer, and on release
       it glides one slide on when the pan was a flick or covered a fifth of
       the width, else back. A pan may start on a slide button; there it needs
       16px, past a tap's wobble, so a sloppy tap still clicks. */
    var FLICK_SPEED = 0.3; /* px/ms over the pan's last 100ms */
    var SWIPE_SHARE = 0.2; /* of the track width, for a slow drag */
    var pan = null;
    var panEndedAt = -1e9;

    /* The slide a horizontal pan settles on when the pointer lifts. */
    function releaseTarget(e) {
      var moves = pan.moves, first = moves[0], last = moves[moves.length - 1];
      var speed = e.timeStamp - last[0] < 100 && last[0] > first[0] ? (last[1] - first[1]) / (last[0] - first[0]) : 0;
      var dragged = pan.pos - pan.startPos;
      var dir = Math.abs(speed) >= FLICK_SPEED ? (speed < 0 ? 1 : -1)
        : Math.abs(dragged) >= SWIPE_SHARE ? (dragged > 0 ? 1 : -1) : 0;
      var to = dir > 0 ? Math.floor(pan.pos) + 1 : dir < 0 ? Math.ceil(pan.pos) - 1 : Math.round(pan.pos);
      var from = Math.round(pan.startPos);
      return clamp(to, Math.max(from - 1, 0), Math.min(from + 1, total - 1));
    }

    function finishPan(e) {
      if (!pan) return;
      if (e && e.pointerId !== pan.id) return;
      var hor = pan.axis === 'x';
      if (hor && track.releasePointerCapture) {
        try { track.releasePointerCapture(pan.id); } catch (_) {}
      }
      track.classList.remove('is-horizontal-panning', 'is-vertical-panning');
      if (hor) {
        panEndedAt = performance.now();
        /* A cancelled pan (the browser or the OS took the pointer) settles on the nearest slide. */
        goTo(e && e.type === 'pointerup' ? releaseTarget(e) : Math.round(pan.pos));
      }
      resumeAfterUser(hor ? 1100 : 350);
      pan = null;
    }

    listen(track, 'pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pan = { id: e.pointerId, startX: e.clientX, startY: e.clientY, startPos: current, pos: current, axis: null, moves: [],
        slop: e.target.closest('.slide-btn') ? 16 : 8 };
      pauseForUser();
    });

    listen(track, 'pointermove', function (e) {
      if (!pan || e.pointerId !== pan.id) return;
      var dx = e.clientX - pan.startX, dy = e.clientY - pan.startY;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (pan.axis !== 'x') {
        if (Math.max(ax, ay) < pan.slop) return;
        /* A touch called vertical that still sends moves 100ms later and 24px
           out was not taken by the browser (it sends pointercancel as soon as
           it scrolls), so it is ours. */
        if (ax <= ay && !(pan.axis === 'y' && e.pointerType !== 'mouse' && ay >= 24 && e.timeStamp - pan.yAt >= 100)) {
          if (!pan.axis) { pan.axis = 'y'; pan.yAt = e.timeStamp; track.classList.add('is-vertical-panning'); }
          return;
        }
        pan.axis = 'x';
        track.classList.remove('is-vertical-panning');
        track.classList.add('is-horizontal-panning');
        if (track.setPointerCapture) {
          try { track.setPointerCapture(pan.id); } catch (_) {}
        }
        pan.startPos = currentPos();
        render(pan.startPos, true); /* freeze a glide in progress under the pointer */
      }
      if (e.cancelable) e.preventDefault();
      pan.moves.push([e.timeStamp, e.clientX]);
      while (e.timeStamp - pan.moves[0][0] > 100) pan.moves.shift();
      pan.pos = clamp(pan.startPos - dx / trackWidth(), 0, total - 1);
      render(pan.pos); /* .is-horizontal-panning disables the transition */
      var idx = Math.round(pan.pos);
      if (idx !== current) setActive(idx); /* videos follow on release */
    }, { passive: false });

    listen(track, 'pointerup', finishPan);
    listen(track, 'pointercancel', finishPan);

    /* The click a pan can leave behind (a mouse drag, or a short touch pan
       that began on a slide button) must not follow the link. */
    listen(track, 'click', function (e) {
      if (performance.now() - panEndedAt > 400) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* A mouse drag on an image or link would start native drag-and-drop after
       a few pixels, which cancels the pointer sequence and with it the pan. */
    listen(track, 'dragstart', function (e) { e.preventDefault(); });

    /* Wheel/trackpad over the hero. Vertical and ambiguous gestures are left to
       the browser, which scrolls the page. A clearly horizontal gesture moves
       one slide per gesture and its events are cancelled so the swipe cannot
       turn into browser back/forward navigation. The axis is decided on the
       first event because Chrome only lets the first wheel event of a gesture
       be cancelled. No wrap-around at the ends, like the pointer drag. */
    var wheelAxis = null;

    listen(track, 'wheel', function (e) {
      if (e.ctrlKey) return; /* trackpad pinch-zoom */
      var ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY);
      if (!ax && !ay) return;
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () { wheelAxis = null; }, 200);
      var axis = ax > ay * 2 ? 'x' : (ay > ax * 2 ? 'y' : null);
      if (wheelAxis && axis && axis !== wheelAxis) wheelAxis = null; /* direction flipped: new gesture */
      if (!wheelAxis) {
        wheelAxis = axis || 'y';
        if (wheelAxis === 'x') {
          e.preventDefault();
          var next = current + (e.deltaX > 0 ? 1 : -1);
          if (next >= 0 && next < total) {
            pauseForUser();
            goTo(next);
            resumeAfterUser(1100);
          }
        }
        return;
      }
      if (wheelAxis === 'x') e.preventDefault();
    }, { passive: false });

    listen(window, 'scroll', function () {
      isPageScrolling = true;
      stopAutoplay();
      clearTimeout(pageScrollTimer);
      pageScrollTimer = setTimeout(function () {
        isPageScrolling = false;
        restartAutoplay();
      }, 180);
    }, { passive: true });

    listen(document, 'visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        stopAutoplay();
        pauseVideos();
      } else {
        syncVideos(current);
        restartAutoplay();
      }
    });

    if (reduceMotion && reduceMotion.addEventListener) {
      listen(reduceMotion, 'change', function () {
        if (reduceMotion.matches) {
          stopAutoplay();
        } else {
          restartAutoplay();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isHeroVisible = entry.isIntersecting;
          if (isHeroVisible) {
            syncVideos(current);
            restartAutoplay();
          } else {
            stopAutoplay();
            pauseVideos();
          }
        });
      }, { threshold: 0.01 });
      visibilityObserver.observe(outer);
    }

    outer._slideshowCleanup = function () {
      stopAutoplay();
      pauseVideos();
      clearTimeout(restartTimer);
      clearTimeout(pageScrollTimer);
      clearTimeout(wheelIdle);
      track.classList.remove('is-horizontal-panning', 'is-vertical-panning');
      pan = null;
      if (visibilityObserver) visibilityObserver.disconnect();
      cleanup.forEach(function (fn) { fn(); });
      outer._slideshowCleanup = null;
    };

    goTo(0, true);
    startAutoplay();
    var tierOff = window.NoticeDeviceTier && (window.NoticeDeviceTier.isLowEnd || window.NoticeDeviceTier.slowNet || window.NoticeDeviceTier.saveData);
    if (timer) hydrateRest(); else if (!tierOff) setTimeout(hydrateRest, 6000);   // low-end / slow / Save-Data: only on the first swipe (review 4 Nov 2026)
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) { outer.addEventListener(ev, hydrateRest, { once: true, passive: true }); });
    if (!timer) {
      var firstImg = firstSlideImg();
      if (firstImg && !imgReady(firstImg)) {
        var onFirstLoad = function () { hydrateRest(); restartAutoplay(250); };
        firstImg.addEventListener('load', onFirstLoad, { once: true });
        firstImg.addEventListener('error', onFirstLoad, { once: true });   // a 404 hero must not stall the rest (review 4 Nov 2026)
        cleanup.push(function () { firstImg.removeEventListener('load', onFirstLoad); firstImg.removeEventListener('error', onFirstLoad); });
      }
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[id^="notice-slideshow-"]').forEach(initSection);
  }

  /* Script is deferred — DOM is fully parsed by the time it runs */
  initAll();

  /* Re-initialize when theme editor reloads a slideshow section */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      var el = event.target.querySelector('[id^="notice-slideshow-"]');
      if (el) initSection(el);
    }
  });

  /* ── Transparent-to-opaque header flip ─────────────────────────────────────
     Watches the hero slideshow with IntersectionObserver. When the hero's
     bottom edge scrolls past the header group (marquee + header), the header
     gets .notice-home-opaque which triggers the cream+dark CSS rules in
     custom.css. Scoped to the homepage only; no-op on any other template. */
  (function () {
    if (!document.body.classList.contains('current-template-index')) return;

    var headerWrapper = document.querySelector('.header-wrapper');
    var marqueeSection = document.querySelector('.shopify-section-announcement-bar');
    var hero = document.querySelector('[id^="notice-slideshow-"]');
    if (!headerWrapper || !hero) return;

    /* Measure actual announcement bar height and expose as CSS variable */
    var marqueeEl = document.querySelector('.announcement-marquee-wrapper');
    if (marqueeEl) {
      document.documentElement.style.setProperty('--announcement-bar-height', marqueeEl.offsetHeight + 'px');
    }

    var heroObserver = null;

    function initHeroObserver() {
      if (heroObserver) heroObserver.disconnect();

      /* header group height = announcement marquee + sticky header.
         --header-height is set by the header's ResizeObserver; fall back to 62px.
         --announcement-bar-height is set above; fall back to 50px. */
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      var mh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'), 10);
      var offset = (isNaN(hh) ? 62 : hh) + (isNaN(mh) ? 50 : mh);

      heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            headerWrapper.classList.remove('notice-home-opaque');
            if (marqueeSection) marqueeSection.classList.remove('notice-marquee-opaque');
          } else {
            headerWrapper.classList.add('notice-home-opaque');
            if (marqueeSection) marqueeSection.classList.add('notice-marquee-opaque');
          }
        });
      }, { rootMargin: '-' + offset + 'px 0px 0px 0px', threshold: 0 });

      heroObserver.observe(hero);
    }

    initHeroObserver();

    /* Re-measure when the header group changes size (async stylesheets arriving after the first
       measurement, orientation change): keeps --announcement-bar-height and the observer offset in
       sync with the corrected --header-height instead of caching a one-time value. */
    if ('ResizeObserver' in window) {
      var remeasureRaf = 0;
      var remeasure = function () {
        if (remeasureRaf) return;
        remeasureRaf = requestAnimationFrame(function () {
          remeasureRaf = 0;
          var m = document.querySelector('.announcement-marquee-wrapper');
          if (m) document.documentElement.style.setProperty('--announcement-bar-height', m.offsetHeight + 'px');
          initHeroObserver();
        });
      };
      var headerSection = document.querySelector('.section-header');
      var sizeObserver = new ResizeObserver(remeasure);
      if (headerSection) sizeObserver.observe(headerSection);
      if (marqueeEl) sizeObserver.observe(marqueeEl);
    }

    /* Re-init when section reloads in theme editor */
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('[id^="notice-slideshow-"]')) {
        heroObserver && heroObserver.disconnect();
        hero = document.querySelector('[id^="notice-slideshow-"]');
        headerWrapper = document.querySelector('.header-wrapper');
        marqueeSection = document.querySelector('.shopify-section-announcement-bar');
        var marqueeElReload = document.querySelector('.announcement-marquee-wrapper');
        if (marqueeElReload) {
          document.documentElement.style.setProperty('--announcement-bar-height', marqueeElReload.offsetHeight + 'px');
        }
        if (hero && headerWrapper) initHeroObserver();
      }
    });
  })();
})();
